import React from 'react'
import { PageHeader } from '@mobi/component-library/Navigation/PageHeader'
import { MainContainer } from '@core/Components/Containers'
import { NoticeBox } from '@core/Components/NoticeBox'
import { ActivityStatementContainer } from '../ActivityStatement.styles'

const CannotFetchData = () => (
  <MainContainer>
    <PageHeader title='Activity Statement Request' />

    <ActivityStatementContainer>
      <NoticeBox
        role='alert'
        testId='unable-to-fetch-account-details'
        noticeBoxType='Error'
        title='Could not fetch account details'
        subtitle='We were unable to fetch your account details'
        hasBorder
      />
    </ActivityStatementContainer>
  </MainContainer>
)

export default CannotFetchData
